<div class="metadata-section">
  <dcc-collapsible-panel
    *ngIf="metadata.deviceType === 'ER'"
    class="metadata-group"
    title="Device">
    <div class="metadata-items">
      <header-and-value
        *ngIf="metadata.operationalState"
        header="Operating State"
        [color]="getOperatingStateColor()"
        [value]="metadata.operationalState"></header-and-value>
      <header-and-value
        header="Last Communication Date"
        type="date"
        [value]="metadata.lastCommunicationDate"></header-and-value>
      <header-and-value
        header="Current Firmware Version"
        [value]="metadata.firmwareVersion?.value"></header-and-value>
      <header-and-value
        header="Expected Firmware Version"
        [value]="getIntendedFirmwareVersion()"></header-and-value>
      <header-and-value
        header="Hardware Version"
        [value]="metadata.hardwareVersion"></header-and-value>
      <header-and-value
        header="Hardware Platform"
        [value]="metadata.platform"></header-and-value>
      <header-and-value
        header="Device Detected Bus Type"
        [value]="metadata.deviceDetectedBusType?.value"></header-and-value>
      <header-and-value
        header="CAN1 Type"
        [value]="metadata.can1Type"></header-and-value>
      <header-and-value
        *ngIf="metadata.platform?.toLowerCase() === 'sf500'"
        header="Factory Initialization Date"
        type="date"
        [value]="metadata.factoryInstallDate"></header-and-value>
      <header-and-value
        header="Initial Dock Date"
        type="date"
        [value]="metadata.initialDockDate"></header-and-value>
      <header-and-value
        *ngIf="metadata.followerSerial"
        header="Follower Serial"
        [value]="metadata.followerSerial"></header-and-value>
      <header-and-value
        *ngIf="metadata.followerState"
        header="Follower State"
        [value]="metadata.followerState"></header-and-value>
      <header-and-value
        *ngIf="deviceEncryptionKey !== undefined"
        header="Device Encryption Key"
        [value]="deviceEncryptionKey"></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    *ngIf="geotabMetadata"
    class="metadata-group"
    title="Telematics Device">
    <span
      class="timeline__header lx-title"
      style="font-size: 15px">
      {{ geotabMetadata.serialNumber }}
    </span>

    <div class="metadata-items">
      <header-and-value
        header="Telematics Connection"
        [value]="getTelematicsConnectionState()"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.lastCommunicationDate"
        header="Telematics Last Communicated"
        type="date"
        [value]="geotabMetadata.lastCommunicationDate"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.firmwareVersion"
        header="Firmware Version"
        [value]="geotabMetadata.firmwareVersion?.value"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.deviceType"
        header="Device Type"
        [value]="geotabMetadata.deviceType"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.initialDockDate"
        header="Initial Dock Date"
        type="date"
        [value]="geotabMetadata.initialDockDate"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.lastPairedMessage"
        header="Last paired message"
        type="date"
        [value]="geotabMetadata.lastPairedMessage"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.lastECMSignal"
        header="Last ECM Signal"
        type="date"
        [value]="geotabMetadata.lastECMSignal"></header-and-value>
    </div>
    <hr
      *ngIf="
        metadata?.can1Type === 'IOX Protocol' ||
        geotabMetadata.hardwareVersion ||
        geotabMetadata.can1Type ||
        geotabMetadata.cableType ||
        geotabMetadata.ioxFirmwareVersion
      " />
    <div class="metadata-items">
      <header-and-value
        *ngIf="metadata?.can1Type && metadata.can1Type === 'IOX Protocol'"
        header="IOX Connection"
        [value]="
          metadata.can1Type === 'IOX Protocol' ? 'Connected' : 'Disconnected'
        "></header-and-value>
      <header-and-value
        header="Hardware Version"
        [value]="geotabMetadata.hardwareVersion"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.can1Type"
        header="CAN1 Type"
        [value]="geotabMetadata.can1Type"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.cableType"
        header="Cable type"
        [value]="geotabMetadata.cableType"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.ioxFirmwareVersion"
        header="IOX Protocol Version"
        [value]="geotabMetadata.ioxFirmwareVersion"></header-and-value>
    </div>
    <hr
      *ngIf="
        geotabMetadata.latLong?.value != null ||
        geotabMetadata.ecmSpeed?.value != null ||
        geotabMetadata.ecmOdometer?.value != null ||
        geotabMetadata.heading != null ||
        geotabMetadata.trackPoint?.timestamp != null
      " />
    <div
      class="metadata-items"
      *ngIf="
        geotabMetadata.latLong?.value != null ||
        geotabMetadata.ecmSpeed?.value != null ||
        geotabMetadata.ecmOdometer?.value != null ||
        geotabMetadata.heading != null ||
        geotabMetadata.trackPoint?.timestamp != null
      ">
      <header-and-value
        *ngIf="geotabMetadata.latLong?.value !== null"
        header="Lat/Long."
        [value]="
          formatLatLongWithDegree(geotabMetadata.latLong?.value)
        "></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.ecmSpeed?.value !== null"
        header="ECM Speed"
        [value]="
          (+geotabMetadata.ecmSpeed?.value * 0.621371).toFixed(4) + ' mph'
        "></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.ecmOdometer?.value !== null"
        header="ECM Odometer"
        [value]="
          geotabMetadata.ecmOdometer?.value + ' miles'
        "></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.heading != null"
        header="ECM Bearing"
        [value]="geotabMetadata.heading"></header-and-value>
      <header-and-value
        *ngIf="geotabMetadata.trackPoint?.timestamp !== null"
        header="Last GPS Signal"
        type="date"
        [value]="geotabMetadata.trackPoint?.timestamp"></header-and-value>
    </div>
    <hr *ngIf="geotabMetadata?.troubleCodes" />
    <div
      class="metadata-items"
      *ngIf="geotabMetadata?.troubleCodes">
      <header-and-value
        *ngIf="geotabMetadata?.troubleCodes"
        header="Diagnostic Codes"
        [value]="
          getLatestDiagnostic(geotabMetadata.troubleCodes).code +
          ' (' +
          getLatestDiagnostic(geotabMetadata.troubleCodes).timestamp +
          ')'
        "></header-and-value>
      <header-and-value
        *ngIf="
          geotabMetadata?.troubleCodes &&
          getLatestDiagnostic(geotabMetadata.troubleCodes).failureMode &&
          geotabMetadata.can1Type === 'J1939'
        "
        header="Failure Mode"
        [value]="
          getLatestDiagnostic(geotabMetadata.troubleCodes).failureMode
        "></header-and-value>
      <header-and-value
        *ngIf="
          geotabMetadata?.troubleCodes &&
          getLatestDiagnostic(geotabMetadata.troubleCodes).faultData
        "
        header="Fault Data"
        [value]="
          getLatestDiagnostic(geotabMetadata.troubleCodes).faultData
        "></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Vehicle">
    <div class="metadata-items">
      <header-and-value
        header="Name"
        [value]="metadata.vehicleName"></header-and-value>
      <header-and-value
        header="Make"
        [value]="metadata.vehicleMake"></header-and-value>
      <header-and-value
        header="Model"
        [value]="metadata.vehicleModel"></header-and-value>
      <header-and-value
        header="Year"
        [value]="metadata.vehicleYear"></header-and-value>
      <header-and-value
        header="VIN"
        [value]="metadata.vin"></header-and-value>
      <header-and-value
        header="Class"
        [value]="metadata.vehicleClass"></header-and-value>
      <header-and-value
        header="ID"
        [value]="metadata.vehicleId"></header-and-value>
      <header-and-value
        header="Ignition On"
        type="date"
        [value]="metadata.ignitionOn"></header-and-value>
      <header-and-value
        header="Ignition Off"
        type="date"
        [value]="metadata.ignitionOff"></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Company">
    <div class="metadata-items">
      <header-and-value
        header="ID"
        [value]="metadata.companyId"></header-and-value>
      <header-and-value
        header="Name"
        [value]="metadata.companyName"></header-and-value>
      <header-and-value
        header="Group"
        [value]="metadata.groupName"></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Events">
    <div class="metadata-items">
      <header-and-value
        header="Last Event"
        type="date"
        [value]="deviceEvent[0]?.triggerTime"></header-and-value>
      <button
        class="lx-btn lx-btn-negative"
        (click)="onDeviceEventSearchClick()">
        View Events
      </button>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="ECM">
    <div class="metadata-items">
      <header-and-value
        header="ECM Engine Speed"
        type="date"
        [value]="metadata.ecmEngineSpeed?.timestamp"></header-and-value>
      <header-and-value
        header="ECM Odometer"
        type="date"
        [value]="metadata.ecmOdometer?.timestamp"></header-and-value>
      <header-and-value
        header="ECM VIN Last Update"
        type="date"
        [value]="metadata.ecmVin?.timestamp"></header-and-value>
      <header-and-value
        header="ECM VIN"
        [value]="metadata.ecmVin?.value"></header-and-value>
      <header-and-value
        header="ECM Engine Hours"
        type="date"
        [value]="metadata.ecmEngineHours?.timestamp"></header-and-value>
      <header-and-value
        header="ECM Speed"
        type="date"
        [value]="metadata.ecmSpeed?.timestamp"></header-and-value>
      <header-and-value
        *ngIf="metadata.heading != null"
        header="ECM Bearing"
        [value]="metadata.heading"></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Install">
    <div class="metadata-items">
      <header-and-value
        header="DILI Record Number"
        [value]="metadata.diliRecordNumber"></header-and-value>
      <header-and-value
        header="Installer Type"
        [value]="metadata.installerType"></header-and-value>
      <header-and-value
        header="Cable Type"
        [value]="metadata.cableType"></header-and-value>
      <header-and-value
        header="Vehicle Width"
        [value]="metadata.vehicleWidth"></header-and-value>
      <header-and-value
        header="Camera Height"
        [value]="metadata.cameraHeight"></header-and-value>
      <header-and-value
        header="Camera Offset"
        [value]="metadata.cameraOffset"></header-and-value>
      <header-and-value
        header="Calibration Status"
        [value]="metadata.calPickStatus"></header-and-value>
      <header-and-value
        header="Salesforce Vehicle Id"
        [value]="metadata.salesforceVehicleId"></header-and-value>
      <header-and-value
        header="HD Vehicle Accessory"
        [value]="metadata.hdVehicleAccessory"></header-and-value>
      <header-and-value
        header="OBDII Accessories"
        [value]="metadata.obdiiAccessories"></header-and-value>
      <header-and-value
        header="Shipped Cable"
        [value]="metadata.shippedCable"></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Settings">
    <div class="metadata-items">
      <header-and-value
        header="J1939 Virtual Ignition Enabled"
        [value]="metadata.j1939VirtualIgnitionEnabled"></header-and-value>
      <header-and-value
        header="Motion Based Ignition Enabled"
        [value]="metadata.motionBasedIgnitionEnabled"></header-and-value>
      <header-and-value
        header="Continuous Data Enabled"
        [value]="metadata.continuousDataEnabled"></header-and-value>
      <header-and-value
        header="VNET Stream Enabled"
        [value]="metadata.vnetStreamEnabled"></header-and-value>
      <header-and-value
        header="Hibernation Delay Minutes"
        [value]="metadata.hibernationDelayMinutes"></header-and-value>
      <header-and-value
        header="Ignition Detect Method"
        [value]="metadata.ignitionDetectMethod"></header-and-value>
      <header-and-value
        header="OBDII Provider"
        [value]="metadata.obdiiProvider"></header-and-value>
      <header-and-value
        header="OBDII Lookup Provider"
        [value]="metadata.obdiiLookupProvider"></header-and-value>
      <header-and-value
        header="Enable OBDII Requests Only If Vehicle is Likely ON"
        [value]="metadata.enableObd2ReqsOnlyIfVehLikelyOn"></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Timestamps">
    <div class="metadata-items">
      <header-and-value
        header="Presence On"
        type="date"
        [value]="metadata.presenceOn"></header-and-value>
      <header-and-value
        header="Presence Off"
        type="date"
        [value]="metadata.presenceOff"></header-and-value>
      <header-and-value
        header="Check In"
        type="date"
        [value]="metadata.checkIn"></header-and-value>
      <header-and-value
        header="SD Card Success"
        type="date"
        [value]="metadata.sdCardSuccess"></header-and-value>
      <header-and-value
        header="SD Card Failure"
        type="date"
        [value]="metadata.sdCardFailure"></header-and-value>
      <header-and-value
        header="Trackpoint"
        type="date"
        [value]="metadata.trackPoint?.timestamp"></header-and-value>
      <header-and-value
        header="Last Accelerometer Date"
        type="date"
        [value]="metadata.lastAccelerometerDateTime"></header-and-value>
      <header-and-value
        header="Last Trip Date"
        type="date"
        [value]="metadata.lastTripDate"></header-and-value>
      <header-and-value
        header="Motion Interval Start"
        type="date"
        [value]="metadata.motionIntervalStart"></header-and-value>
      <header-and-value
        header="Motion Without Ignition Span"
        [value]="metadata.motionWithoutIgnitionSpan"></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Modules">
    <div
      *ngIf="!deviceVersion"
      class="module-versions__not-found">
      No Device Version Response
    </div>
    <div
      *ngIf="deviceVersion?.moduleVersions?.length === 0"
      class="module-versions__no-modules">
      No modules deployed
    </div>
    <ng-container *ngFor="let module of deviceVersion?.moduleVersions">
      <div class="module-versions module-divider">
        <header-and-value
          header="Module Name"
          [value]="module.name"></header-and-value>
        <header-and-value
          header="Version On Device"
          [value]="module.versionOnDevice"></header-and-value>
        <header-and-value
          header="Expected Version"
          [value]="module.expectedVersion?.version"></header-and-value>
        <header-and-value
          header="Status"
          [ignoreValue]="true">
          <dcc-status-indicator
            [color]="getModuleStatusColor(module.status)"
            [value]="module.status"></dcc-status-indicator>
        </header-and-value>
        <header-and-value
          header="Release"
          [value]="module.expectedVersion?.releaseName"></header-and-value>
        <header-and-value
          header="Cohort"
          [value]="module.expectedVersion?.cohortMembershp"></header-and-value>
      </div>
    </ng-container>
  </dcc-collapsible-panel>

  <div
    *ngIf="enableBatteryView"
    class="metadata-group">
    <span class="metadata-title">Device Battery</span>
    <div class="metadata-items">
      <header-and-value
        header="Battery Health"
        [color]="getBatteryHealthColor()"
        [value]="getBatteryHealthLabel()"></header-and-value>
      <header-and-value
        header="Charge Status"
        [value]="getBatteryFieldValue('chargeStatus')"></header-and-value>
      <header-and-value
        header="Battery Type"
        [value]="getBatteryFieldValue('batteryIssueManufacturerName')"></header-and-value>
      <header-and-value
        header="Avg. Battery Temp"
        [value]="getBatteryFieldValue('batteryBackupStatsAvgBatteryTemp')"></header-and-value>
      <header-and-value
        header="Resistance Ohms"
        [value]="getBatteryFieldValue('batteryBackupStatsResistanceOhms')"></header-and-value>
      <header-and-value
        header="Power Loss Events"
        [value]="getBatteryFieldValue('batteryBackupStatsPowerLossEvents')"></header-and-value>
      <header-and-value
        header="Max Battery Voltage"
        [value]="getBatteryFieldValue('batteryBackupStatsMaxBatteryVoltage')"></header-and-value>
      <header-and-value
        header="Low Voltage Events"
        [value]="getBatteryFieldValue('batteryBackupStatsLowVoltageRechargeAttempts')"></header-and-value>
      <header-and-value
        header="Idle Discharge Time"
        [value]="getBatteryFieldValue('batteryBackupStatsTotalIdleDischargeTimeSeconds')"></header-and-value>
      <header-and-value
        header="Ignition Time"
        [value]="getBatteryFieldValue('batteryBackupStatsTotalChargeEnabledSeconds')"></header-and-value>
    </div>
  </div>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Miscellaneous">
    <div class="metadata-items">
      <header-and-value
        header="Uptime"
        type="date"
        [value]="metadata.upTime?.value"></header-and-value>
      <header-and-value
        header="System Voltage"
        type="date"
        [value]="metadata.systemVoltage?.value"></header-and-value>
      <header-and-value
        header="Battery Voltage"
        type="date"
        [value]="metadata.batteryVoltage?.value"></header-and-value>
      <header-and-value
        header="Remaining Wake Time On Modem"
        type="date"
        [value]="metadata.remainingWakeOnModemTime?.value"></header-and-value>
      <header-and-value
        header="Status ID"
        [value]="metadata.statusId"></header-and-value>
    </div>
  </dcc-collapsible-panel>

  <dcc-collapsible-panel
    class="metadata-group"
    title="Images">
    <div class="images-row">
      <lightgallery
        class="images-row__gallery"
        [settings]="settings">
        <header-and-value
          *ngFor="let tile of cameraTiles"
          header="{{ tile.label }}"
          [ignoreValue]="true">
          <a
            *ngIf="tile.url; else noSignalTile"
            class="gallery-item"
            [href]="tile.url">
            <img
              class="images-row__thumb"
              [alt]="tile.label"
              [title]="tile.label"
              [src]="tile.url" />
          </a>
          <ng-template #noSignalTile>
            <div class="images-row__thumb images-row__no-signal">No Signal</div>
          </ng-template>
        </header-and-value>
      </lightgallery>
      <div class="images-row__actions">
        <div class="images-row__action-buttons">
          <button
            type="button"
            class="lx-btn lx-btn-negative request-new-image-btn"
            [disabled]="requestingImages || isErOffline"
            [title]="isErOffline ? 'Device is offline' : ''"
            (click)="onRequestNewImage()">
            <i
              class="lx-icon lx-reset"
              [class.spin]="requestingImages"></i>
            <span>{{ requestingImages ? 'Requesting image…' : 'Request New Image' }}</span>
          </button>
          <button
            *ngIf="metadata.followerSerial"
            class="lx-btn lx-btn-negative view-hub-aux-btn"
            type="button"
            (click)="onViewHubAuxClick()">
            View Hub &amp; Aux
          </button>
        </div>
        <span
          *ngIf="liveImageError"
          class="live-image-error">
          {{ liveImageError }}
        </span>
      </div>
    </div>
    <header-and-value
      *ngIf="photos"
      header="Image Capture"
      [value]="photoTakenDate"></header-and-value>
  </dcc-collapsible-panel>
</div>
